/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type developmentVerificationStep_form$ref = any;
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type CompleteDevelopmentRegistrationInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type developmentVerificationStepCompleteMutationVariables = {|
  input: CompleteDevelopmentRegistrationInput
|};
export type developmentVerificationStepCompleteMutationResponse = {|
  +completeDevelopmentRegistration: ?{|
    +developmentRegistrationForm: ?{|
      +step: ?DevelopmentRegistrationStep,
      +$fragmentRefs: developmentVerificationStep_form$ref,
    |}
  |}
|};
export type developmentVerificationStepCompleteMutation = {|
  variables: developmentVerificationStepCompleteMutationVariables,
  response: developmentVerificationStepCompleteMutationResponse,
|};
*/


/*
mutation developmentVerificationStepCompleteMutation(
  $input: CompleteDevelopmentRegistrationInput!
) {
  completeDevelopmentRegistration(input: $input) {
    developmentRegistrationForm {
      ...developmentVerificationStep_form
      step
      id
    }
  }
}

fragment developmentVerificationStep_form on DevelopmentRegistrationForm {
  id
  verified
  completed
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "step",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "developmentVerificationStepCompleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteDevelopmentRegistrationPayload",
        "kind": "LinkedField",
        "name": "completeDevelopmentRegistration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentRegistrationForm",
            "kind": "LinkedField",
            "name": "developmentRegistrationForm",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "developmentVerificationStep_form"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "developmentVerificationStepCompleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteDevelopmentRegistrationPayload",
        "kind": "LinkedField",
        "name": "completeDevelopmentRegistration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentRegistrationForm",
            "kind": "LinkedField",
            "name": "developmentRegistrationForm",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verified",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completed",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc7e9a9b73602d5deebf1afc2e0cdfa6",
    "id": null,
    "metadata": {},
    "name": "developmentVerificationStepCompleteMutation",
    "operationKind": "mutation",
    "text": "mutation developmentVerificationStepCompleteMutation(\n  $input: CompleteDevelopmentRegistrationInput!\n) {\n  completeDevelopmentRegistration(input: $input) {\n    developmentRegistrationForm {\n      ...developmentVerificationStep_form\n      step\n      id\n    }\n  }\n}\n\nfragment developmentVerificationStep_form on DevelopmentRegistrationForm {\n  id\n  verified\n  completed\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '652ea8aa8dd94d8bf8aa75ddcd39a8cf';

export default node;
